<div role="tablist" class="tabs">
  <div class="tabs-nav">
    <div class="tabs-headings" part="tabs-heading">
      @for (tab of tabs(); track tab.label) {
        <button
          role="tab"
          [disabled]="tab.disabled"
          class="tab-heading"
          [ngClass]="{
            'tab-heading-active': tab.open,
            'tab-heading-disabled': tab.disabled,
            'toggle-mode': toggleMode(),
          }"
          (click)="openTab(tab)"
        >
          @if (tab.imgSrc) {
            <img
              class="h-5 w-5"
              [class.mr-3]="!!tab.label"
              alt="icon"
              [src]="tab?.imgSrc"
            />
          }
          <span>{{ tab.label }}</span>
        </button>
      }
    </div>
  </div>
</div>
